/* HANIA STUDIO v3 — touch/drag hero slider, mouse-drag rows, horizontal infinite reel viewer, rotating reel popup */
(function () {
  'use strict';
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return [].slice.call((c || document).querySelectorAll(s)); }

  /* ---------- Hero: finger-follow swipe slider ---------- */
  $$('[data-hx-swipe]').forEach(function (s) {
    var stage = $('.hx-hs__stage', s), track = $('.hx-hs__track', s);
    var slides = $$('.hx-slide', track), dots = $$('[data-hx-dot]', s), n = slides.length;
    var i = 0, timer = null, delay = parseInt(s.dataset.delay || 6000, 10);
    function go(k) {
      i = (k + n) % n;
      track.style.transform = 'translate3d(' + (-i * 100) + '%,0,0)';
      slides.forEach(function (el, j) { el.classList.toggle('on', j === i); el.setAttribute('aria-hidden', j === i ? 'false' : 'true'); });
      dots.forEach(function (d, j) { d.classList.remove('on'); if (j === i) { void d.offsetWidth; d.classList.add('on'); } });
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } s.classList.add('paused'); }
    function play() { stop(); if (n < 2) return; s.classList.remove('paused'); timer = setInterval(function () { go(i + 1); }, delay); }
    var pv = $('[data-hx-sprev]', s), nx = $('[data-hx-snext]', s);
    if (pv) pv.addEventListener('click', function () { go(i - 1); play(); });
    if (nx) nx.addEventListener('click', function () { go(i + 1); play(); });
    dots.forEach(function (d, j) { d.addEventListener('click', function () { go(j); play(); }); });
    s.addEventListener('mouseenter', stop); s.addEventListener('mouseleave', play);
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else play(); });

    var down = false, sx = 0, sy = 0, dx = 0, axis = null, moved = false, w = 1, t0 = 0;
    stage.addEventListener('pointerdown', function (e) {
      if (n < 2 || (e.pointerType === 'mouse' && e.button !== 0)) return;
      down = true; axis = null; moved = false; dx = 0; sx = e.clientX; sy = e.clientY; w = stage.clientWidth || 1; t0 = Date.now();
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      dx = e.clientX - sx; var dy = e.clientY - sy;
      if (!axis && (Math.abs(dx) > 7 || Math.abs(dy) > 7)) axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      if (axis === 'y') { down = false; return; }
      if (axis === 'x') {
        moved = true; stop(); track.classList.add('drag');
        var edge = (i === 0 && dx > 0) || (i === n - 1 && dx < 0) ? 0.35 : 1;
        track.style.transform = 'translate3d(' + (-i * w + dx * edge) + 'px,0,0)';
      }
    }, { passive: true });
    function end() {
      if (!down) return; down = false;
      track.classList.remove('drag');
      if (axis === 'x') {
        var fast = Math.abs(dx) > 20 && (Date.now() - t0) < 300;
        if (Math.abs(dx) > w * 0.1 || fast) go(dx < 0 ? i + 1 : i - 1); else go(i);
        play();
      }
    }
    window.addEventListener('pointerup', end);
    window.addEventListener('pointercancel', end);
    stage.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    stage.addEventListener('dragstart', function (e) { e.preventDefault(); });
    go(0); play();
  });

  /* ---------- Rows & reels: mouse drag on desktop (touch scrolls natively) ---------- */
  $$('[data-hx-car-track]').forEach(function (tr) {
    var down = false, sx = 0, sl = 0, moved = false;
    tr.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true; moved = false; sx = e.clientX; sl = tr.scrollLeft;
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var d = e.clientX - sx;
      if (!moved && Math.abs(d) > 6) { moved = true; tr.classList.add('hx-grab'); }
      if (moved) tr.scrollLeft = sl - d;
    });
    window.addEventListener('pointerup', function () {
      if (!down) return; down = false;
      if (moved) {
        var c = tr.querySelector('.hs-reel, .hx-card') || tr.firstElementChild;
        var cs = getComputedStyle(tr), gap = parseFloat(cs.columnGap) || parseFloat(cs.gap) || 0;
        var step = c ? c.getBoundingClientRect().width + gap : 1;
        var target = Math.round(tr.scrollLeft / step) * step;
        tr.classList.remove('hx-grab');
        tr.scrollTo({ left: target, behavior: 'smooth' });
        tr.dataset.dragged = '1';
        setTimeout(function () { moved = false; tr.dataset.dragged = ''; }, 60);
      }
    });
    tr.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
    tr.addEventListener('dragstart', function (e) { e.preventDefault(); });
  });

  /* ---------- Reel viewer: horizontal finger swipe, infinite loop (13 → 1) ---------- */
  var ICON = {
    left: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M15 6l-6 6 6 6"/></svg>',
    right: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"/></svg>',
    mute: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M11 5 6 9H2v6h4l5 4V5z"/><path d="m23 9-6 6M17 9l6 6"/></svg>',
    sound: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M11 5 6 9H2v6h4l5 4V5z"/><path d="M15.5 8.5a5 5 0 0 1 0 7M19 5a10 10 0 0 1 0 14"/></svg>',
    play: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M8 5v14l11-7z"/></svg>'
  };
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function cardData(card) {
    var d = null; try { d = JSON.parse($('.hs-reel-data', card).textContent); } catch (e) {}
    var v = $('video', card), srcs = [];
    if (v) {
      $$('source', v).forEach(function (so) { srcs.push({ src: so.src || so.getAttribute('src'), type: so.getAttribute('type') || '' }); });
      if (!srcs.length && v.getAttribute('src')) srcs.push({ src: v.src, type: '' });
    }
    var pi = $('.hs-reel__poster', card);
    var poster = pi ? (pi.currentSrc || pi.src) : '';
    if (!poster && v) poster = v.poster || v.getAttribute('poster') || '';
    return { d: d, srcs: srcs, poster: poster };
  }
  function makeVideo(srcs, poster, opts) {
    var v = document.createElement('video');
    v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', ''); v.playsInline = true;
    v.muted = opts.muted !== false; if (v.muted) v.setAttribute('muted', '');
    v.loop = !!opts.loop; v.preload = opts.preload || 'auto';
    if (poster) v.poster = poster;
    srcs.forEach(function (x) {
      if (/mpegurl/i.test(x.type) && !v.canPlayType('application/vnd.apple.mpegurl')) return;
      var so = document.createElement('source'); so.src = x.src; if (x.type) so.type = x.type; v.appendChild(so);
    });
    return v;
  }

  var RV = null, rvItems = [], rvIdx = 0, rvMuted = false, rvEls = {}, rvBusy = false;
  function mod(x) { var n = rvItems.length; return ((x % n) + n) % n; }
  function buildRV() {
    RV = document.createElement('div');
    RV.className = 'hx-rv'; RV.setAttribute('role', 'dialog'); RV.setAttribute('aria-label', 'Reels');
    RV.innerHTML = '<div class="hx-rv__stage"></div>' +
      '<div class="hx-rv__top"><span class="hx-rv__count"></span><div class="hx-rv__tbtns"><button type="button" class="hx-rv__ibtn hx-rv__mute" aria-label="Sound"></button><button type="button" class="hx-rv__ibtn hx-rv__x" aria-label="Close">&times;</button></div></div>' +
      '<div class="hx-rv__nav"><button type="button" class="hx-rv__ibtn" data-rv="-1" aria-label="Previous reel">' + ICON.left + '</button><button type="button" class="hx-rv__ibtn" data-rv="1" aria-label="Next reel">' + ICON.right + '</button></div>' +
      '<div class="hx-rv__hint">Swipe \u2190 \u2192 for more</div>';
    document.body.appendChild(RV);
    var stage = $('.hx-rv__stage', RV);
    $('.hx-rv__x', RV).addEventListener('click', closeRV);
    $('.hx-rv__mute', RV).addEventListener('click', function () {
      rvMuted = !rvMuted; $$('video', stage).forEach(function (v) { v.muted = rvMuted; }); setMute();
      var a = curVideo(); if (a && a.paused) a.play().catch(function () {});
    });
    $$('[data-rv]', RV).forEach(function (b) { b.addEventListener('click', function () { commit(parseInt(b.dataset.rv, 10)); }); });
    document.addEventListener('keydown', function (e) {
      if (!RV.classList.contains('open')) return;
      if (e.key === 'Escape') closeRV();
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); commit(1); }
      if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); commit(-1); }
    });

    var down = false, sx = 0, sy = 0, dx = 0, dy = 0, t0 = 0, axis = null, moved = false;
    stage.addEventListener('pointerdown', function (e) {
      if (rvBusy || (e.pointerType === 'mouse' && e.button !== 0)) return;
      if (e.target.closest('.hx-rv__card')) return;
      down = true; moved = false; axis = null; dx = dy = 0; sx = e.clientX; sy = e.clientY; t0 = Date.now();
      if (stage.setPointerCapture) { try { stage.setPointerCapture(e.pointerId); } catch (er) {} }
    });
    stage.addEventListener('pointermove', function (e) {
      if (!down) return;
      dx = e.clientX - sx; dy = e.clientY - sy;
      if (!axis && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) axis = Math.abs(dx) >= Math.abs(dy) ? 'x' : 'y';
      if (axis) moved = true;
      if (axis === 'x') position(dx, false);
    });
    function end() {
      if (!down) return; down = false;
      if (axis === 'x') {
        var w = stage.clientWidth || 1, fast = Math.abs(dx) > 20 && (Date.now() - t0) < 300;
        if (Math.abs(dx) > w * 0.12 || fast) commit(dx < 0 ? 1 : -1); else position(0, true);
      } else if (axis === 'y') {
        if (Math.abs(dy) > 50) commit(dy < 0 ? 1 : -1);
      }
    }
    stage.addEventListener('pointerup', end);
    stage.addEventListener('pointercancel', end);
    stage.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; return; }
      var addB = e.target.closest('[data-rv-add]');
      if (addB) { addToBag(addB); return; }
      if (e.target.closest('.hx-rv__card')) return;
      var sl = rvEls[rvIdx]; var v = sl && $('video', sl); if (!v) return;
      if (v.paused) { v.play().catch(function () {}); sl.classList.remove('paused'); } else { v.pause(); sl.classList.add('paused'); }
    }, true);
  }
  function setMute() { $('.hx-rv__mute', RV).innerHTML = rvMuted ? ICON.mute : ICON.sound; }
  function curVideo() { var sl = rvEls[rvIdx]; return sl ? $('video', sl) : null; }
  function slideEl(i) {
    if (!rvEls[i]) {
      var w = document.createElement('div'); w.innerHTML = slideHTML(rvItems[i], i);
      rvEls[i] = w.firstChild;
    }
    return rvEls[i];
  }
  function slots() {
    var n = rvItems.length;
    if (n === 1) return [[0, rvIdx]];
    if (n === 2) return [[0, rvIdx], [1, mod(rvIdx + 1)]];
    return [[-1, mod(rvIdx - 1)], [0, rvIdx], [1, mod(rvIdx + 1)]];
  }
  function position(dx, anim) {
    var stage = $('.hx-rv__stage', RV);
    stage.classList.toggle('anim', !!anim);
    var n = rvItems.length;
    slots().forEach(function (s) {
      var k = s[0];
      if (n === 2 && k === 1 && dx > 0) k = -1;
      slideEl(s[1]).style.transform = 'translate3d(calc(' + (k * 100) + '% + ' + dx + 'px),0,0)';
    });
  }
  function place() {
    var stage = $('.hx-rv__stage', RV), keep = {};
    slots().forEach(function (s) { keep[s[1]] = 1; var el = slideEl(s[1]); if (el.parentNode !== stage) stage.appendChild(el); });
    Object.keys(rvEls).forEach(function (k) {
      if (!keep[k] && rvEls[k].parentNode) { var v = $('video', rvEls[k]); if (v) v.pause(); rvEls[k].parentNode.removeChild(rvEls[k]); }
    });
    position(0, false);
  }
  function commit(dir) {
    if (rvBusy || rvItems.length < 2) return;
    rvBusy = true;
    var stage = $('.hx-rv__stage', RV), n = rvItems.length, nextI = mod(rvIdx + dir);
    var cur = slideEl(rvIdx), nx = slideEl(nextI);
    if (nx.parentNode !== stage) stage.appendChild(nx);
    if (n === 2) nx.style.transform = 'translate3d(' + (dir * 100) + '%,0,0)';
    void stage.offsetWidth;
    stage.classList.add('anim');
    cur.style.transform = 'translate3d(' + (-dir * 100) + '%,0,0)';
    nx.style.transform = 'translate3d(0,0,0)';
    var pv = $('video', cur); if (pv) pv.pause();
    RV.classList.add('scrolled');
    setTimeout(function () {
      rvIdx = nextI; stage.classList.remove('anim');
      place(); activate(); rvBusy = false;
    }, 260);
  }
  function ensureVideo(i) {
    var it = rvItems[i]; if (!it || !it.srcs.length) return null;
    var sl = slideEl(i), media = $('.hx-rv__media', sl), v = $('video', media);
    if (!v) {
      v = makeVideo(it.srcs, it.poster, { muted: rvMuted, loop: true, preload: 'auto' });
      media.insertBefore(v, media.firstChild.nextSibling);
      var bar = $('.hx-rv__bar i', sl);
      v.addEventListener('timeupdate', function () { if (v.duration) bar.style.width = (v.currentTime / v.duration * 100) + '%'; });
    }
    return v;
  }
  function activate() {
    var n = rvItems.length, i = rvIdx;
    $('.hx-rv__count', RV).textContent = (i < 9 ? '0' : '') + (i + 1) + ' / ' + (n < 10 ? '0' : '') + n;
    Object.keys(rvEls).forEach(function (k) { if (+k !== i) { var ov = $('video', rvEls[k]); if (ov) ov.pause(); } });
    var v = ensureVideo(i);
    if (n > 1) { ensureVideo(mod(i + 1)); ensureVideo(mod(i - 1)); }
    if (v) {
      v.muted = rvMuted;
      var p = v.play();
      if (p && p.catch) p.catch(function () { rvMuted = true; v.muted = true; setMute(); v.play().catch(function () {}); });
      rvEls[i].classList.remove('paused');
    }
    $('.hx-rv__mute', RV).style.visibility = v ? 'visible' : 'hidden';
  }
  function slideHTML(it, i) {
    var d = it.d || {};
    var canAdd = d.available && !d.multi && d.variant;
    return '<section class="hx-rv__slide" data-i="' + i + '"><div class="hx-rv__media">' +
      (it.poster ? '<img class="hx-rv__poster' + (it.srcs.length ? '' : ' kb') + '" src="' + esc(it.poster) + '" alt="" draggable="false">' : '<span></span>') +
      '<div class="hx-rv__bar"><i></i></div><span class="hx-rv__paused">' + ICON.play + '</span>' +
      (d.title ? '<div class="hx-rv__card">' + (d.image ? '<img src="' + esc(d.image) + '" alt="">' : '') +
        '<div class="hx-rv__info"><p class="hx-rv__t">' + esc(d.title) + '</p><p class="hx-rv__p">' + esc(d.price) + '</p></div>' +
        '<div class="hx-rv__btns">' + (canAdd ? '<button type="button" class="hx-rv__btn" data-rv-add="' + d.variant + '">Add to Bag</button>' : '') +
        '<a class="hx-rv__btn' + (canAdd ? ' alt' : '') + '" href="' + esc(d.url) + '">' + (d.multi ? 'Select Size' : 'View') + '</a></div></div>' : '') +
      '</div></section>';
  }
  function addToBag(b) {
    var id = b.getAttribute('data-rv-add'); b.textContent = 'Adding…'; b.disabled = true;
    var root = (window.routes && window.routes.root_url) || '/'; if (root.slice(-1) !== '/') root += '/';
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function () {
        b.textContent = 'Added ✓';
        var c = $$('[data-hx-count]'); fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) { c.forEach(function (x) { x.textContent = cart.item_count; x.classList.toggle('hide', !cart.item_count); }); });
      })
      .catch(function () { b.textContent = 'Try again'; b.disabled = false; });
  }
  function openRV(cards, start) {
    if (!RV) buildRV();
    rvItems = cards.map(cardData); rvEls = {}; rvIdx = Math.max(0, Math.min(start, rvItems.length - 1)); rvBusy = false;
    $('.hx-rv__stage', RV).innerHTML = '';
    $$('.hs-reel video').forEach(function (v) { v.pause(); });
    RV.classList.add('open'); RV.classList.remove('scrolled');
    RV.classList.toggle('single', rvItems.length < 2);
    document.documentElement.style.overflow = 'hidden';
    setMute(); place(); activate();
  }
  function closeRV() {
    if (!RV) return;
    $$('video', RV).forEach(function (v) { v.pause(); });
    $('.hx-rv__stage', RV).innerHTML = ''; rvEls = {};
    RV.classList.remove('open');
    document.documentElement.style.overflow = '';
  }
  function cardOpen(e) {
    var card = e.target.closest && e.target.closest('.hs-reel'); if (!card) return;
    if (e.target.closest('.hs-reel__prod')) return;
    var tr = card.closest('[data-hx-car-track]'); if (tr && tr.dataset.dragged === '1') return;
    var sec = card.closest('[data-hs-reels]'); if (!sec) return;
    e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    var list = $$('.hs-reel', sec);
    openRV(list, Math.max(0, list.indexOf(card)));
  }
  document.addEventListener('click', cardOpen, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Enter') cardOpen(e); }, true);

  /* ---------- Floating reel popup: cycles through all reels ---------- */
  var rp = $('[data-hx-rpop]');
  if (rp) {
    var closed = false;
    try { closed = sessionStorage.getItem('hxRpop') === '0'; } catch (e) {}
    var bubble = $('[data-hx-rpop-open]', rp);
    if (closed || !bubble) { rp.remove(); }
    else {
      var cards = $$('.hx-rpop__src .hs-reel', rp), items = cards.map(cardData), k = 0, tmr = null, stopped = false;
      var stage = document.createElement('span'); stage.className = 'hx-rpop__stage';
      $$(':scope > video, :scope > img', bubble).forEach(function (el) { el.remove(); });
      bubble.insertBefore(stage, bubble.firstChild);
      var next = function () { if (!stopped && items.length) show((k + 1) % items.length); };
      var show = function (idx) {
        clearTimeout(tmr); k = idx;
        var it = items[idx], el;
        if (it.srcs.length) {
          el = makeVideo(it.srcs, it.poster, { muted: true, loop: false, preload: 'auto' });
          el.addEventListener('ended', next);
          el.addEventListener('error', function () { clearTimeout(tmr); tmr = setTimeout(next, 3000); }, true);
          tmr = setTimeout(next, 15000);
        } else {
          el = document.createElement('img'); el.src = it.poster; el.alt = ''; el.className = 'kb';
          tmr = setTimeout(next, 4000);
        }
        el.classList.add('hx-rpop__m');
        stage.appendChild(el);
        if (el.play) { var p = el.play(); if (p && p.catch) p.catch(function () {}); }
        requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add('in'); }); });
        var olds = $$('.hx-rpop__m', stage).filter(function (o) { return o !== el; });
        setTimeout(function () { olds.forEach(function (o) { if (o.pause) o.pause(); o.remove(); }); }, 700);
      };
      setTimeout(function () { rp.classList.add('show'); if (items.length) show(0); }, 2500);
      bubble.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); openRV(cards, k); });
      var x = $('[data-hx-rpop-close]', rp);
      if (x) x.addEventListener('click', function () {
        stopped = true; clearTimeout(tmr);
        rp.classList.remove('show');
        $$('video', stage).forEach(function (v) { v.pause(); });
        try { sessionStorage.setItem('hxRpop', '0'); } catch (e) {}
      });
    }
  }
})();
